import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './Caption.module.css';

class Caption extends PureComponent {
  render() {
    const { children } = this.props;
    return <p styleName="caption">{children}</p>;
  }
}

Caption.propTypes = {
  children: PropTypes.node
};

export default Caption;
